import { render, staticRenderFns } from "./Transactions.vue?vue&type=template&id=97dd1a7a&"
import script from "./Transactions.vue?vue&type=script&lang=js&"
export * from "./Transactions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/miryamfv/Proyectos/valet/dz0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('97dd1a7a')) {
      api.createRecord('97dd1a7a', component.options)
    } else {
      api.reload('97dd1a7a', component.options)
    }
    module.hot.accept("./Transactions.vue?vue&type=template&id=97dd1a7a&", function () {
      api.rerender('97dd1a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/reports/Transactions.vue"
export default component.exports